/**
 * Shared (client + server) transformer: converts a combo group into modifier-shaped
 * data. Used by the client selector getProductComboGroupsAsModifiers and by the server
 * product transformer. productTransformer is optional (default identity) so the client
 * can use store data as-is; the server passes its productTransformer.
 */

const identity = x => x;

const comboGroupProductToModifierValueTransformer = (
  comboGroupProduct,
  comboGroupId,
  productTransformer = identity
) => {
  if (
    comboGroupProduct.product &&
    (!comboGroupProduct.product?.enabled || comboGroupProduct.product.snoozed)
  )
    return {};
  return {
    id: comboGroupProduct.id,
    combo_group_product_id: comboGroupProduct.id,
    combo_group_id: comboGroupId,
    value: comboGroupProduct.product.name,
    maximum: 1,
    product: comboGroupProduct.product && productTransformer(comboGroupProduct.product),
    price_adjustment: comboGroupProduct.price_adjustment,
    sort_order: comboGroupProduct.sort_order,
    default_value: comboGroupProduct.default,
  };
};

const comboGroupToModifierTransformer = (comboGroup, productTransformer = identity) => {
  const values =
    comboGroup.combo_group_products &&
    comboGroup.combo_group_products
      .map(cgp =>
        comboGroupProductToModifierValueTransformer(cgp, comboGroup.id, productTransformer)
      )
      .filter(value => !!value?.id);
  if (!values?.length) return {};
  return {
    id: comboGroup.id,
    combo_group_id: comboGroup.id,
    values,
    display_name: comboGroup.display_name,
    name: comboGroup.name,
    use_as_quantity: false,
    minimum: parseInt(comboGroup.min, 10) || null,
    maximum: parseInt(comboGroup.max, 10) || null,
    step: null,
    type: 'choice',
    sort_order: comboGroup.sort_order,
    multiple: (parseInt(comboGroup.max, 10) || null) > (parseInt(comboGroup.min, 10) || null),
    required: (parseInt(comboGroup.min, 10) || null) > 0,
    display_type: 'list',
  };
};

module.exports = {
  comboGroupToModifierTransformer,
  comboGroupProductToModifierValueTransformer,
};
